import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const OjetaUpravenaList = lazy(() =>
  import('@/modules/ojeta-vozidla/OjetaUpravenaList').then((m) => ({
    default: m.OjetaUpravenaList,
  })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/upravena',
  component: () => (
    <Suspense fallback={null}>
      <OjetaUpravenaList />
    </Suspense>
  ),
});
